var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCircleAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85787 16.5 1.5 13.1421 1.5 9C1.5 4.85787 4.85787 1.5 9 1.5C13.1421 1.5 16.5 4.85787 16.5 9ZM9.02879 4.38461C9.50673 4.38461 9.89417 4.77206 9.89417 5.25V9.76264C9.89417 10.2406 9.50673 10.628 9.02879 10.628C8.55085 10.628 8.16341 10.2406 8.16341 9.76264V5.25C8.16341 4.77206 8.55085 4.38461 9.02879 4.38461ZM9.02884 11.8847C9.50678 11.8847 9.89423 12.2721 9.89423 12.7501V12.7548C9.89423 13.2327 9.50678 13.6202 9.02884 13.6202C8.55091 13.6202 8.16346 13.2327 8.16346 12.7548V12.7501C8.16346 12.2721 8.55091 11.8847 9.02884 11.8847Z",
    fill: "#03A65B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCircleAlert);
export default __webpack_public_path__ + "static/media/ic-circle-alert.6a4b663ffbe6f854e6c90bc0b0d0c2a5.svg";
export { ForwardRef as ReactComponent };